// Contact API
import { apiClient } from './base';

export const contactAPI = {
  // Submit contact form
  submitContactForm: async (contactData) => {
    try {
      const response = await apiClient.post('/api/contact', contactData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  }
};
